import React, { createContext, useState, useEffect, useContext } from "react";
import { useConfig } from "../config";
import { toast } from "react-hot-toast";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const { config } = useConfig();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialCheckDone, setInitialCheckDone] = useState(false);

  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // Login function (sends email with login link)
  const login = async (email, redirectUrl = "/") => {
    try {
      //console.log("Login with redirect URL:", redirectUrl);

      const response = await fetch(`${config.API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          redirect_url: redirectUrl,
        }),
      });

      // Log the request body for debugging
      // console.log(
      //   "Login request body:",
      //   JSON.stringify({
      //     email,
      //     redirect_url: redirectUrl,
      //   })
      // );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Login failed");
      }

      toast.success("Login link sent! Please check your email.");
      return true;
    } catch (error) {
      toast.error("Failed to send login link. Please try again.");
      //console.error("Login error:", error);
      throw error;
    }
  };

  // Logout function
  const logout = async () => {
    
    try {
      setLoading(true);
      const response = await fetch(`${config.API_BASE_URL}/api/auth/logout?userId=${localStorage.getItem("user_id")}&email=${localStorage.getItem("email")}`, {
        method: "POST",
        credentials: "include", // Important for sending cookies
      });

      if (response.ok) {
	      //console.log("Logout successsfully");
        localStorage.removeItem("user_id");
        localStorage.removeItem("email");
        localStorage.removeItem("user_type");
        setUser(null);
        toast.success("Logged out successfully");
	      localStorage.setItem("logout", Date.now());
        // Force a page reload to ensure all state is cleared
        window.location.href = "/login";
      } else {
        toast.error("Logout failed. Please try again.");
      }
    } catch (error) {
      //console.error("Logout error:", error);
      toast.error("Logout failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        initialCheckDone,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
